<template>
  <div class="">
    <el-container>
      <el-main>
        <div class="box">
          <el-form :inline="true" size="small">
            <el-form-item>
              <el-input v-model.trim="queryParams.accountName" placeholder="账户名" />
            </el-form-item>
            <el-form-item>
              <el-select v-model="queryParams.status" placeholder="提取状态">
                <el-option :value="0" label="待审核" />
                <el-option :value="1" label="通过" />
                <el-option :value="2" label="驳回" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-date-picker v-model="queryParams.selectDatetimest" type="datetime" placeholder="选择提交开始时间" @change="dataSearchSt" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-date-picker v-model="queryParams.selectDatetimeed" type="datetime" placeholder="选择提交结束时间" @change="dataSearchEd" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-form>
          <div>
            <el-button size="small" @click="list(1)" type="primary" plain icon="el-icon-search">搜索</el-button>
            <el-button size="small"  type="primary" plain icon="el-icon-s-check" v-on:click="diaFormVisiblePass = true">批量通过</el-button>
            <el-button size="small"  type="primary" plain icon="el-icon-s-check" v-on:click="diaFormVisibleNo = true">批量驳回</el-button>
            <el-button size="small" @click="download" type="primary" plain icon="el-icon-download">导出</el-button>
          </div>
        </div>
        <el-table  @selection-change="selectIdChange" ref="multipleTable" :data="tableData" :row-style="{height:'40px',textAlign:'center'}"
                   :cell-style="{height:'5px,0',textAlign:'center'}"
                   :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
                   border style="width: 100%;margin-top: 1%;height: 70vh">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="id" label="Id" width="50">
          </el-table-column>
          <el-table-column prop="agentId" label="代理商Id" width="150">
          </el-table-column>
          <el-table-column prop="agentName" label="代理商" width="150">
          </el-table-column>
          <el-table-column prop="accountName" label="账户名" width="100">
          </el-table-column>
          <el-table-column prop="account" label="收款账户" width="130">
          </el-table-column>

          <el-table-column prop="money" label="提现金额" width="100">
          </el-table-column>
          <el-table-column prop="arrival" label="到账金额" width="100">
          </el-table-column>
          <el-table-column prop="createTime" label="提交提现时间" width="180">
          </el-table-column>

          <el-table-column prop="status" label="提取状态" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.status===0">待审核</div>
              <div v-if="scope.row.status===1">通过</div>
              <div v-if="scope.row.status===2">驳回</div>
            </template>
          </el-table-column>
          <el-table-column prop="giveOut" label="是否已发放" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.giveOut===0">未发放</div>
              <div v-if="scope.row.giveOut===1">已发放</div>
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="处理提现时间" width="180">
          </el-table-column>
          <el-table-column prop="upUser" label="处理人">
          </el-table-column>
          <el-table-column prop="info" label="备注" min-width="150">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button type="primary" size="small">
                  操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="profitInfo(scope.row.agentId)">剩余返佣</el-dropdown-item>
                  <el-dropdown-item  @click.native="pass(scope.row)">审核通过</el-dropdown-item>
                  <el-dropdown-item  @click.native="noPass(scope.row)">驳回申请</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>

        </el-table>
        <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>

        <el-dialog v-if="disProfitInfo" :close-on-click-modal="false"  title="代理商返佣信息" :visible.sync="disProfitInfo" class="class_dialog_hospital" width="20%">
          <el-form ref="tableProfite" :model="tableProfite" :rules="rules"  >
            <el-form-item label="代理商Id：" prop="agentId">
              <el-input v-model="tableProfite.agentId" style="width: 100%;" readonly />
            </el-form-item>
            <el-form-item label="返佣金额：" prop="profitPrice">
              <el-input v-model="tableProfite.profitPrice.toFixed(2)+'元'" style="width: 100%;" readonly />
            </el-form-item>
          </el-form>
        </el-dialog>

        <el-dialog v-if="diaProData" :close-on-click-modal="false"  title="审核通过" :visible.sync="diaProData" class="class_dialog_hospital" width="25%">
          <el-form ref="tableDataId" :model="tableDataId" >
            <el-form-item label="审核 Id：" prop="id">
              <el-input v-model="tableDataId.id" readonly />
            </el-form-item>
            <el-form-item label="提现金额：" prop="money" >
              <el-input v-model="tableDataId.money" readonly />
            </el-form-item>
            <el-form-item label="账户 名：" prop="accountName">
              <el-input v-model="tableDataId.accountName" readonly />
            </el-form-item>
            <el-form-item label="收款账户：" prop="account">
              <el-input v-model="tableDataId.account" readonly />
            </el-form-item>
            <el-form-item label="备注：">
              <el-input v-model="tableDataId.info" placeholder='请输入备注信息' />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="diaProData = false">取 消</el-button>
            <el-button size="small" type="primary" @click="addProData('tableDataId','sure')">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog v-if="noProData" :close-on-click-modal="false" data-height="700" title="驳回申请" :visible.sync="noProData" class="class_dialog_hospital" width="30%">
          <el-form ref="tableDataId" :model="tableDataId"  :rules="rules">
            <el-form-item label="审核 Id：" prop="id">
              <el-input v-model="tableDataId.id" readonly />
            </el-form-item>

            <!--<el-form-item label="提现金额：" prop="money">
              <el-input v-model="tableDataId.money" readonly />
            </el-form-item>
            <el-form-item label="账户 名：" prop="accountName">
              <el-input v-model="tableDataId.accountName" readonly />
            </el-form-item>-->
            <el-form-item label="驳回原因：">
              <el-input v-model.trim="tableDataId.info" placeholder='请填写驳回原因' />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="noProData = false">取 消</el-button>
            <el-button size="small" type="primary" @click="addProData('tableDataId','fail')">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="批量通过" :visible.sync="diaFormVisiblePass" class="class_dialog_hospital" width="40%">
          <div style="margin-bottom:80px;">
            <p style="color:red">ID号为：{{ids}} 的申请您将要进行批量审核通过操作！</p>
            <el-col style=""><span>备注：</span>
              <el-input v-model.trim="plinfo" style="width:42%;" placeholder='请输入备注信息' />
            </el-col>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="diaFormVisiblePass = false">取 消</el-button>
            <el-button size="small" type="primary" @click="batchPass()">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="批量驳回" :visible.sync="diaFormVisibleNo" class="class_dialog_hospital" width="40%">
          <div style="margin-bottom:80px;">
            <p style="color:red">ID号为：{{ids}} 的申请您将要进行批量审核驳回操作！</p>
            <el-col style=""><span>驳回原因：</span>
              <el-input v-model.trim="plinfo" style="width:42%;" placeholder='请填写驳回原因' />
            </el-col>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="diaFormVisibleNo = false">取 消</el-button>
            <el-button size="small" type="primary" @click="batchNoPass()">确 定</el-button>
          </div>
        </el-dialog>

      </el-main>
    </el-container>

  </div>
</template>

<script>
import Pagination from '../../../components/pagination'
import check from '../../../static/js/check'
import tools from '../../../utils/tools'

export default {
  name: 'sysExtractRecord',
  components: {
    Pagination
  },

  mounted: function () {
  },

  data() {
    return {
      maxHeight: 500,
      disProfitInfo: false,
      diaFormVisibleNo: false,
      diaFormVisiblePass: false,
      tableData: [],
      tableProfite: [],
      tableDataId: {
        check: ''
      },
      isDisabled: true,
      diaProData: false,
      noProData: false,
      multipleSelection: [],
      ids: '',
      plinfo: '',
      queryParams:{
        selectDatetimest: '',
        selectDatetimeed: '',
        current: 1,
        size: 10,
        accountName:'',
        status: '',
      },
      profitJs: require('../../../api/profit')
    }
  },

  created() {
  },
  methods: {

    dataSearchSt(data) {
      this.queryParams.selectDatetimest=data
    },
    dataSearchEd(data) {
      this.queryParams.selectDatetimeed=data
    },

    list(page) {
      let _this = this
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      if (_this.selectDatetimeed === null) {
        _this.selectDatetimeed = ''
      }
      if (_this.selectDatetimest === null) {
        _this.selectDatetimest = ''
      }
      _this.queryParams.current = page
      _this.queryParams.size =_this.$refs.pagination.size
      _this.profitJs.getTxList(_this.queryParams)
        .then(response => {
          _this.tableData = response.data.data.rows
          _this.$refs.pagination.render(page, response.data.data.total)
        })
    },
    pass(row){
      this.commpass(row)
      this.diaProData=true
    },
    noPass(row){
      this.commpass(row)
      this.noProData=true
    },
    //审核通过
    commpass(row) {
      let _this = this
      _this.tableDataId = row
    },
    profitInfo(agentId) {
      let _this = this
      _this.disProfitInfo = true
      _this.profitJs.getProfitInfo( agentId).then(response => {
        _this.tableProfite = response.data.data
      })
    },
    selectIdChange(val) {
      let _this = this
      _this.multipleSelection = val
      let array = new Array()
      for (let i in _this.multipleSelection) {
        let section = _this.multipleSelection[i]
        let id = section.id
        array.push(id)
      }
      let str = array.join(',')
      _this.ids = str
    },
    //确定
    addProData(tableDataId,val) {
      let _this = this
      if (val==='fail' && check.checkIsNull(_this.tableDataId.info)) {
        _this.$alert('驳回操作请注明原因！')
        return false
      }
      _this.$refs[tableDataId].validate(valid => {
        if (valid) {
          _this.tableDataId.check = val
          _this.profitJs.checkSucc(_this.tableDataId,val).then(res => {
            if (res.data.code === '0') {
              _this.$alert(res.data.data)
            } else {
              _this.$alert(res.data.msg)
            }
            _this.diaProData = false
            _this.noProData=false
          })
        } else {
          _this.$alert('审核失败！')
          return false
        }
      })
    },
    //驳回
    noPass(id) {
      let _this = this
      _this.noProData = true
    },
    //plPass
    batchPass() {
      let _this = this
      if (_this.ids.length == 0) {
        _this.$swal('请先勾选需要审核的数据！')
        return false
      }
      let date={ids: _this.ids, plinfo: _this.plinfo}
      _this.profitJs.plBatchPass(date).then(res => {
        if (res.data.code === '0') {
          _this.$notify.success(res.data.data)
          _this.diaFormVisiblePass = false
        } else {
          _this.$notify.error(res.data.msg)
          _this.diaFormVisiblePass = false
        }
      })
    },
    //plNoPass
    batchNoPass() {
      let _this = this
      if (_this.ids.length == 0) {
        _this.$swal('请先勾选需要审核的数据！')
        return false
      }
      if (check.checkIsNull(_this.plinfo)) {
        _this.$swal('驳回操作请注明原因！')
        return false
      }

      let date={ids: _this.ids, plinfo: _this.plinfo}
      _this.profitJs.plBatchNoPass(date).then(res => {
        if (res.data.code === '0') {
          _this.$notify.success(res.data.data)
          _this.diaFormVisibleNo = false
        } else {
          _this.$notify.success(res.data.msg)
          _this.diaFormVisibleNo = false
        }
      })
    },



    download() {
      let _this = this
      _this
      .$confirm('由于导出数据需要一定时间，请确定是否需要下载。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        _this.profitJs.importTxList(_this.queryParams)
                .then(res => {
                  if(res.data.code==='0'){
                    _this.$alert('已操作导出，请稍后到功能模块：业务管理中的执行任务管理下载查看！')
                  }else{
                    _this.$alert(res.data.msg)
                  }

                })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消！'
        })
      })

    }
  }
}
</script>

<style lang="less" scoped>
  ::v-deep .el-table__fixed-body-wrapper{
    height: calc(100% - 48px ) !important;
  }
  /* 设置滚动条宽度和高度 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  ::v-deep .el-table {
    height: 88%;
  .el-table__body-wrapper {
    height: calc(100% - 48px) !important; // 表格高度减去表头的高度
  overflow-y: auto;
  }
  }



  ::v-deep.el-button--primary {
    color: #409EFF;
    background: #ecf5ff;
    border-color: #b3d8ff;
  }

._select {
  width: 20%;
  height: 34px;
}
.pup {
  float: right;
}
.col-md-3 {
  float: left;
}
.btns {
  margin-left: 30px;
}
</style>
<style scoped>
/deep/.el-table .el-table__cell {
  padding: 0px;
}
/deep/thead.has-gutter {
  height: 40px;
}
.box {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}


</style>